import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';

@Component({
  selector: 'hcf-person-service-category',
  templateUrl: './person-service-category.component.html',
  styleUrls: ['./person-service-category.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PersonServiceCategoryComponent implements OnChanges {
  @Input() serviceCategoryName: string;
  @Input() placeDetails: WebApiModel.Place[];
  @Input() componentIndex: number;
  @Input() numberOfServiceCategories: number;

  filteredPlaceDetails: WebApiModel.Place[];
  detailsHidden: boolean = true;
  numberOfPlaces: number = 0;

  // Don't use ngOnInit, it's only triggered once when loading the first profile,
  // doesn't fire again when navigating to another person profile.
  // This is the default angular router behavour - reusing components.
  // There was an issue when this component wasn't refreshing when the 'serviceCategory' variable in ngFor in the parenent component
  // had the same value as the previous person profile, e.g. when browsing people who all had 'General practitioner' service category
  // the locations didn't update when navigating between the GP profiles.
  ngOnChanges() {
    // expand the first category by default if there are more than one
    this.detailsHidden = this.numberOfServiceCategories > 1 || this.componentIndex > 0;

    // or always expand the first one
    // this.detailsHidden = (this.componentIndex > 0);

    const filteredPlacesByServiceCategory: WebApiModel.Place[] = [];
    this.placeDetails.forEach((place) => {
      place.serviceCategories.forEach((category) => {
        if (category.name === this.serviceCategoryName) {
          filteredPlacesByServiceCategory.push(place);
        }
      });
    });
    this.filteredPlaceDetails = filteredPlacesByServiceCategory;

    if (this.filteredPlaceDetails) {
      this.numberOfPlaces = this.filteredPlaceDetails.length;
    }
  }

  setDetailsVisible(): void {
    this.detailsHidden = !this.detailsHidden;
  }
}
